import { UI, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionCardProps } from '..';
import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useSubscriptionDetailContext } from '../../../contexts/SubscriptionDetail';
import { SubscriptionInfo } from '../components/SubscriptionInfo';
import { SubscriptionMainInfo } from '../components/SubscriptionMainInfo';

export const SubscriptionCardMobile: React.FC<SubscriptionCardProps> = ({
  openDetails,
  subscription,
}) => {
  const { setModalOpen, setSubscriptionSelected } = useSubscriptionDetailContext();

  const handleOpenItemDetailsModal = () => {
    setModalOpen(true);
    setSubscriptionSelected(subscription);
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack justifyContent="space-between" space="stack.nano">
          <SubscriptionMainInfo
            description={`ISIN: ${subscription.baseIsinCode}`}
            title={subscription.productDisplay}
            onDetailsPress={handleOpenItemDetailsModal}
            hasLeftovers={subscription.hasLeftovers}
            isMobile
          />
          <SubscriptionInfo
            label="Data Execução"
            value={subscription.executionDateFormatted}
            isMobile
          />
          <SubscriptionInfo label="Data limite" value={subscription.limitDateFormatted} isMobile />
          <SubscriptionInfo
            label="Data liquidação"
            value={subscription.settlementDateFormatted}
            isMobile
          />
          <SubscriptionInfo
            label="Clientes aptos"
            value={`${subscription.customersEligible}`}
            isMobile
          />
          <SubscriptionInfo
            label="Preço unitário"
            value={subscription.unitaryPriceFormatted}
            isMobile
          />
          <UI.IconButton
            p={0}
            variant="textLink"
            alignSelf="end"
            isDisabled={false}
            icon="ArrowRight"
            iconColor="brand.primary.principal"
            iconSize="xxs"
            testId="details-button"
            onPress={openDetails}
          />
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
